// extracted by mini-css-extract-plugin
module.exports = {"page_header_title":"styles_page_header_title__v5tdu"};